
export enum ReportTypes{
    Campaign_Report,
    Production_Plan_Report
}

 export interface ReportType{
    reportType:string;
    reportName:string;   
}

export class ReportIdentifier{
   
    public static getReportByType(reportType:string):ReportType{

        switch(reportType) {
            case "1":
                return this.getReport(ReportTypes.Campaign_Report);

            case "2" : 
             return this.getReport(ReportTypes.Production_Plan_Report);

            default:
                break;
        }

        return null as unknown as ReportType;
        
    }


    public static getReport(reportType: ReportTypes): ReportType {
        switch (reportType) {
            case ReportTypes.Campaign_Report:
                return {reportType:"1", reportName: "Campaign plan Report.xls"};
            case ReportTypes.Production_Plan_Report:
                return {reportType:"2", reportName: "Production Plan Report.xls"};
          
        }
    }
}